<template>
  <div>

    <el-main>
      <template>
        <el-tabs v-model="activeName"
                 type="card">
          <el-tab-pane label="报告记录"
                       name="report">
            <report />
          </el-tab-pane>
          <el-tab-pane label="定时报告"
                       name="autoReport">
            <autoReport />
          </el-tab-pane>
          <el-tab-pane label="营业状况"
                       name="sales">
            <sales />
          </el-tab-pane>
          <el-tab-pane label="用户管理"
                       name="user">
            <user />
          </el-tab-pane>
          <el-tab-pane label="CSMAR用户管理"
                       name="csmarUser">
            <csmarUser />
          </el-tab-pane>

          <el-tab-pane label="代理商管理"
                       name="proxy">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <template>
                    <el-table :data="proxyPageInfo.records"
                              style="width: 100%">
                      <el-table-column prop="proxyName"
                                       label="代理商"
                                       width="120">
                      </el-table-column>
                      <el-table-column prop="proxyCode"
                                       label="代理代码"
                                       width="120">
                      </el-table-column>

                      <el-table-column prop="proxyKey"
                                       label="加密KEY"
                                       width="140">
                      </el-table-column>
                      <el-table-column prop="proxyUserUrl"
                                       label="获取用户URL">

                      </el-table-column>
                      <el-table-column label="状态"
                                       width="100">
                        <template slot-scope="scope">
                          {{scope.row.status | statusFilter}}

                        </template>
                      </el-table-column>
                      <el-table-column label="操作"
                                       width="140">
                        <template slot-scope="scope">

                          <el-button type="text"
                                     @click="toMifiyProxyInfo(scope.row.id)"
                                     size="small">编辑</el-button>
                          <el-button type="text"
                                     @click="toDelProxyInfo(scope.row.id)"
                                     size="small">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-row>
                <el-row>
                  <br>
                  <el-pagination background
                                 @current-change="getProxyList"
                                 layout="prev, pager, next,total"
                                 :current-page="proxyPageInfo.current"
                                 :page-size="proxyPageInfo.size"
                                 :total="proxyPageInfo.total">
                  </el-pagination>

                </el-row>
              </el-col>

              <el-col :span="12">
                <el-form :model="curProxyForm"
                         label-width="80px">
                  <el-form-item label="代理商名称">
                    <el-input v-model="curProxyForm.proxyName"></el-input>
                  </el-form-item>
                  <el-form-item label="代理商代码">
                    <el-input v-model="curProxyForm.proxyCode"></el-input>
                  </el-form-item>
                  <el-form-item label="获取用户URL">
                    <el-input v-model="curProxyForm.proxyUserUrl"></el-input>
                  </el-form-item>
                  <el-form-item label="代理商密钥">
                    <el-input v-model="curProxyForm.proxyKey"></el-input>
                  </el-form-item>
                  <el-form-item label="代理商模式">
                    <el-select v-model="curProxyForm.proxyType"
                               placeholder="代理商模式">
                      <el-option label="单帐号模式"
                                 value="SINGLE"></el-option>
                      <el-option label="机构模式"
                                 value="ORGANIZE"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="生成次数">
                    <el-input v-model="curProxyForm.limitCount"></el-input>
                  </el-form-item>

                  <el-form-item label="帐号权限">
                    <el-select v-model="curProxyForm.roles"
                               placeholder="请选择权限">
                      <el-option label="VIP"
                                 value="VIP"></el-option>
                      <el-option label="SVIP"
                                 value="SVIP"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="创建日期">
                    <el-col :span="11">
                      <el-date-picker :disabled=true
                                      type="date"
                                      placeholder="选择日期"
                                      v-model="curProxyForm.createTime"></el-date-picker>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="状态"
                                prop="status">
                    <el-switch v-model="curProxyForm.status"
                               active-color="#13ce66"
                               inactive-color="#ff4949"
                               active-value="ENABLE"
                               inactive-value="DISABLE">
                    </el-switch>
                  </el-form-item>

                  <el-form-item>
                    <template v-if="curProxyForm && curProxyForm.id">
                      <el-button type="primary"
                                 @click="editProxyInfo">修改</el-button>
                    </template>
                    <template v-else>
                      <el-button type="primary"
                                 @click="addProxyInfo">添加</el-button>
                    </template>
                    <el-button @click="curProxyForm={}">清空</el-button>
                  </el-form-item>
                </el-form>
              </el-col>

            </el-row>
          </el-tab-pane>
          <el-tab-pane label="学校管理"
                       name="school">
            <el-form :inline="true"
                     :model="schoolSearchForm"
                     class="demo-form-inline">
              <el-form-item label="代理商">
                <el-select v-model="schoolSearchForm.proxyId"
                           placeholder="请选择代理商">
                  <template v-for="item in proxyPageInfo.records">
                    <el-option :key="item.id"
                               :label="item.proxyName"
                               :value="item.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>

              <el-form-item label="学校名称">
                <el-input v-model="schoolSearchForm.name"
                          placeholder="学校名称"></el-input>
              </el-form-item>
              <el-form-item label="学校编码">
                <el-input v-model="schoolSearchForm.code"
                          placeholder="学校编码"></el-input>
              </el-form-item>

              <!-- <el-form-item label="用户来源">
                      <el-select v-model="userSearchForm.userType" placeholder="用户类型">
                        <el-option label="代理用户" value="PROXY"></el-option>
                        <el-option label="注册用户" value="REGISTER"></el-option>
                      </el-select>
                    </el-form-item> -->
              <el-form-item>
                <el-button type="primary"
                           @click="getSchoolList()">查询</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col :span="16">
                <template>
                  <el-table :data="schoolPageInfo.records"
                            style="width: 100%">
                    <el-table-column prop="schoolCode"
                                     label="学校code"
                                     width="100">
                    </el-table-column>
                    <el-table-column prop="schoolName"
                                     label="学校名称">
                    </el-table-column>

                    <el-table-column prop="limitCount"
                                     label="生成次数"
                                     width="60">
                    </el-table-column>

                    <el-table-column prop="roles"
                                     label="帐号权限"
                                     width="60">
                    </el-table-column>
                    <el-table-column label="有效期"
                                     width="100">
                      <template slot-scope="scope">
                        {{scope.row.expireTime |dateFilter}}
                      </template>
                    </el-table-column>

                    <el-table-column prop="proxyName"
                                     label="代理商"
                                     width="80">
                    </el-table-column>
                    <el-table-column label="ip白名单"
                                     width="200">
                      <template slot-scope="scope">
                        <template v-for="(item,index) in scope.row.whiteIpList">
                          <div :key="index">
                            {{item.startIp}}- {{item.endIp}}
                          </div>
                        </template>
                      </template>
                    </el-table-column>

                    <el-table-column label="状态"
                                     width="60">
                      <template slot-scope="scope">
                        {{scope.row.status | statusFilter}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click="toMifiySchoolInfo(scope.row)"
                                   size="small">编辑</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-row>
                    <br>
                    <el-pagination background
                                   @current-change="getSchoolList"
                                   layout="prev, pager, next,total"
                                   :current-page="schoolPageInfo.current"
                                   :page-size="schoolPageInfo.size"
                                   :total="schoolPageInfo.total">
                    </el-pagination>

                  </el-row>
                </template>
              </el-col>
              <el-col :span="8">
                <el-form :model="schoolFrom"
                         label-width="80px">

                  <el-form-item style="display:none">
                    <el-input :value="schoolFrom.refresh +''">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="学校名称">
                    <el-input v-model="schoolFrom.schoolName ">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="学校代码">
                    <el-input v-model="schoolFrom.schoolCode"></el-input>
                  </el-form-item>

                  <el-form-item label="生成次数">
                    <el-input v-model="schoolFrom.limitCount"></el-input>
                  </el-form-item>

                  <el-form-item label="帐号权限">
                    <el-select v-model="schoolFrom.roles"
                               placeholder="请选择权限">
                      <el-option label="VIP"
                                 value="VIP"></el-option>
                      <el-option label="SVIP"
                                 value="SVIP"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="代理商">
                    <el-select v-model="schoolFrom.proxyId"
                               placeholder="请选择代理商">
                      <template v-for="item in proxyPageInfo.records">
                        <el-option :key="item.id"
                                   :label="item.proxyName"
                                   :value="item.id"></el-option>
                      </template>
                    </el-select>
                  </el-form-item>

                  <el-form-item v-for="(item, index) in schoolFrom.whiteIpList"
                                :label="'IP白名单' + index"
                                :key="index">
                    <el-col :span="10">
                      <el-input @input="schoolFrom.refresh=!schoolFrom.refresh"
                                v-model="item.startIp"></el-input>
                    </el-col>
                    <el-col class="line"
                            :span="1">-</el-col>
                    <el-col :span="10">
                      <el-input @input="schoolFrom.refresh=!schoolFrom.refresh"
                                v-model="item.endIp"></el-input>
                    </el-col>
                    <el-col class="line"
                            :span="3">
                      <el-button @click.prevent="removeWhiteIp(index)">删除</el-button>
                    </el-col>
                  </el-form-item>

                  <el-form-item>
                    <el-button @click="addWhiteIpItem">新增IP段</el-button>
                  </el-form-item>

                  <el-form-item label="有效期至">
                    <el-col :span="11">
                      <el-date-picker type="date"
                                      placeholder="选择日期"
                                      value-format="timestamp"
                                      v-model="schoolFrom.expireTime"></el-date-picker>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="状态"
                                prop="status">
                    <el-switch v-model="schoolFrom.status"
                               active-color="#13ce66"
                               inactive-color="#ff4949"
                               active-value="ENABLE"
                               inactive-value="DISABLE">
                    </el-switch>
                  </el-form-item>

                  <el-form-item>
                    <template v-if="schoolFrom && schoolFrom.id">
                      <el-button type="primary"
                                 @click="editSchoolInfo">修改</el-button>
                    </template>
                    <template v-else>
                      <el-button type="primary"
                                 @click="editSchoolInfo">添加</el-button>
                    </template>
                    <el-button @click="schoolFrom={}">清空</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="套餐管理"
                       name="price">
            <price />
          </el-tab-pane>

        </el-tabs>
      </template>
    </el-main>

    <!--添加任务弹框--->
    <el-dialog width="500"
               top="0"
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl"
              style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <el-button @click="toDownload(sourceId)"
                 size="small">下载</el-button>
    </el-dialog>

  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import axios from 'axios'
import myNav from '../components/nav'
import myMenu from '../components/menu'
import price from '../components/admin/price'
import user from '../components/admin/user'
import sales from '../components/admin/sales'
import report from '../components/admin/report'
import autoReport from '../components/admin/autoReport'
import csmarUser from '../components/admin/csmarUser '

import moment from 'moment'
export default {
  name: 'admin',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 5,
        records: [],
        total: 1
      },
      schoolSearchForm: {
        name: '',
        code: '',
        proxyId: ''
      },
      userSearchForm: {
        mobile: '',
        userType: 'REGISTER'

      },
      pdfDialogVisible: false,
      pdfUrl: '',
      sourceId: '',
      activeName: 'report',
      userForm: {
        name: '',
        id: '',
        mobile: '',
        status: 'ENABLE'
      },
      userRules: {},
      optType: 'user',

      reportPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      reportUserId: '',
      prices: [],
      accountForm: {},
      accountRule: {},
      accountTime: 0,

      taskForm: {
        type: 'FULL'
      },
      options: [],
      candidateOptions: [],
      conceptOptions: [],
      candidateConcept: [],

      taskPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      // 代理商管理相关
      proxyPageInfo: {
        current: 1,
        size: 100,
        records: [],
        total: 1
      },
      curProxyForm: {},

      // 学校列表
      schoolPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      schoolFrom: {
        refresh: false
      },

      proxyList: []

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    taskStatusFilter: function (v) {
      switch (v) {
        case 'TRUE':
          return '已完成'
        case 'FALSE':
          return '未完成'
        default:
          return v
      }
    },
    typeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '股票'
        case 'CONCEPT':
          return '概念'
      }
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'STOCK_COMPARE':
          return '投资组合'
        default:
          break
      }
    },
    statusFilter: function (v) {
      switch (v) {
        case 'ENABLE':
          return '可用'
        case 'DISABLE':
          return '禁用'
        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {
    removeWhiteIp (index) {
      this.schoolFrom.whiteIpList.splice(index, 1)
    },
    addWhiteIpItem () {
      if (!this.schoolFrom.whiteIpList) {
        this.schoolFrom.whiteIpList = []
      }
      let temp = JSON.parse(JSON.stringify(this.schoolFrom.whiteIpList))
      temp.push({ startIp: '', endIp: '' })
      this.schoolFrom.whiteIpList = temp
      this.schoolFrom.refresh = !this.schoolFrom.refresh
    },
    toMifiySchoolInfo (schoolInfo) {
      this.schoolFrom = schoolInfo
    },
    getSchoolList (val) {
      if (!val) {
        val = 1
      }
      this.schoolPageInfo.current = val
      let _this = this
      axios.get('/api/web/admin/schoolList?page=' + this.schoolPageInfo.current + '&pageSize=' + this.schoolPageInfo.size + '&code=' + this.schoolSearchForm.code +
        '&name=' + this.schoolSearchForm.name + '&proxyId=' + this.schoolSearchForm.proxyId
      ).then(resp => {
        _this.schoolPageInfo = resp.data
        _this.schoolPageInfo.total = parseInt(_this.schoolPageInfo.total)
        _this.schoolPageInfo.current = parseInt(_this.schoolPageInfo.current)
        _this.schoolPageInfo.size = parseInt(_this.schoolPageInfo.size)
      })
    },
    editSchoolInfo () {
      let _this = this
      this.schoolFrom.whiteIps = JSON.stringify(this.schoolFrom.whiteIpList)
      let temp = JSON.parse(JSON.stringify(this.schoolFrom))
      temp.whiteIpList = []
      axios.post('/api/web/school/upsertSchoolInfo', temp).then(resp => {
        _this.getSchoolList()
        _this.$message({
          message: '学校信息修改成功',
          type: 'success'
        })
      })
    },

    addProxyInfo () {
      let _this = this
      axios.post('/api/web/admin/saveProxy', this.curProxyForm).then(resp => {
        _this.getProxyList()
        _this.$message({
          message: '代理商信息添加成功',
          type: 'success'
        })
      })
    },
    editProxyInfo () {
      let _this = this
      axios.put('/api/web/admin/saveProxy', this.curProxyForm).then(resp => {
        _this.getProxyList()
        _this.$message({
          message: '代理商信息修改成功',
          type: 'success'
        })
      })
    },
    toDelProxyInfo (id) {
      let _this = this
      this.curProxyInfo = {}
      axios.get('/api/web/admin/delProxy/' + id).then(resp => {
        _this.getProxyList()
        _this.$message({
          message: '代理商信息删除成功',
          type: 'success'
        })
      })
    },
    toMifiyProxyInfo (id) {
      let _this = this
      this.curProxyInfo = {}
      axios.get('/api/web/admin/proxyInfo/' + id).then(resp => {
        _this.curProxyForm = resp.data
      })
    },

    searchConcept (query) {
      if (query !== '') {
        setTimeout(() => {
          this.conceptOptions = this.candidateConcept.filter(item => {
            return ((item.bk_code.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.bk_name.toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.conceptOptions = []
      }
    },

    searchStock (query) {
      if (query !== '') {
        setTimeout(() => {
          this.options = this.candidateOptions.filter(item => {
            return ((item.name.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.options = []
      }
    },

    selectPrice (id) {
      let price = {}
      for (var i in this.prices.VIP) {
        if (this.prices.VIP[i].id === id) {
          price = this.prices.VIP[i]
          break
        }
      }
      for (var j in this.prices.SVIP) {
        if (this.prices.SVIP[j].id === id) {
          price = this.prices.SVIP[j]
          break
        }
      }

      if (price) {
        this.accountTime = price.time
        this.accountForm.timeUnit = price.timeUnit
        this.accountForm.limitCount = price.limitCount
        this.accountForm.expireTime = new Date().getTime() + price.time * 24 * 60 * 60 * 1000
      }
    },
    eidtAccount (row) {
      this.userForm = JSON.parse(JSON.stringify(row))
      this.optType = 'account'
      axios.get('/api/web/admin/account/' + row.id).then(resp => {
        this.accountForm = resp.data
      })
    },

    showReports (row) {
      this.optType = 'report'
      this.reportUserId = row.id
      this.reportPageInfo.current = 1
      this.reportPageInfo.records = []
      this.getReportList()
    },
    getReportList () {
      let _this = this
      axios.get('/api/web/admin/reports?page=' + this.reportPageInfo.current + '&pageSize=' + this.reportPageInfo.size + '&userId=' + this.reportUserId).then(resp => {
        _this.reportPageInfo = resp.data
        _this.reportPageInfo.total = parseInt(_this.reportPageInfo.total)
        _this.reportPageInfo.current = parseInt(_this.reportPageInfo.current)
        _this.reportPageInfo.size = parseInt(_this.reportPageInfo.size)
      })
    },

    getProxyList () {
      let _this = this
      axios.get('/api/web/admin/proxyList?page=' + this.proxyPageInfo.current + '&pageSize=' + this.proxyPageInfo.size).then(resp => {
        _this.proxyPageInfo = resp.data
        _this.proxyPageInfo.total = parseInt(_this.proxyPageInfo.total)
        _this.proxyPageInfo.current = parseInt(_this.proxyPageInfo.current)
        _this.proxyPageInfo.size = parseInt(_this.proxyPageInfo.size)
      })
    },

    editUser (row) {
      this.optType = 'user'
      this.userForm = JSON.parse(JSON.stringify(row))
    },
    saveUser () {
      axios.post('/api/web/admin/saveUser', this.userForm).then(resp => {
        this.getUserList()
        this.userForm = {}
        this.$message({
          message: '用户信息修改成功',
          type: 'success'
        })
      })
    },
    saveAccount () {
      axios.post('/api/web/admin/saveAccount', this.accountForm).then(resp => {
        this.accountForm = {}
        this.$message({
          message: '账户信息修改成功',
          type: 'success'
        })
      })
    },
    cancelUser () {
      this.userForm = {}
      this.getUserList()
    },
    toRead (sourceId) {
      this.sourceId = sourceId
      this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      this.pdfDialogVisible = true
    },
    toDownload (sourceId) {
      window.open('/api/web/admin/downLoadPdf/' + sourceId)
    },
    getUserList (val) {
      if (val) {
        this.pageInfo.current = val
      }
      let _this = this
      axios.get('/api/web/admin/users?page=' + this.pageInfo.current +
        '&pageSize=' + this.pageInfo.size +
        '&userType=' + this.userSearchForm.userType +
        '&mobile=' + this.userSearchForm.mobile
      ).then(resp => {
        _this.pageInfo = resp.data
        _this.pageInfo.total = parseInt(_this.pageInfo.total)
        _this.pageInfo.current = parseInt(_this.pageInfo.current)
        _this.pageInfo.size = parseInt(_this.pageInfo.size)
        _this.tableLoading = false
      })
    }
  },
  components: {
    myNav, myMenu, Dropzone, price, user, sales, report, autoReport, csmarUser
  },
  mounted () {
    let _this = this
    axios.get('/api/web/admin/priceList').then(resp => {
      _this.prices = resp.data
      if (_this.prices && _this.prices.SVIP[0]) {
        _this.selectPrice(this.prices.SVIP[0].id)
      }
    })

    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data.data
      _this.loading = false
    })
    axios.get('/api/web/concept/concepts').then(resp => {
      _this.candidateConcept = resp.data.data
    })

    this.getProxyList()
    this.getSchoolList()
  },
  watch: {
    accountTime () {
      this.accountForm.time = this.accountTime
      this.accountForm.expireTime = new Date().getTime() + this.accountTime * 24 * 60 * 60 * 1000
    }
  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/admin.vue